import PropTypes from "prop-types";
import React from "react";

import { Checkbox } from "@mui/material";
import { Box } from "@mui/system";

const CheckboxFieldTable = React.memo((props) => {
    return (
        <Box display={"flex"} justifyContent={"center"}>
            <Checkbox
                name={props.name}
                size="small"
                checked={props.value !== undefined ? props.value : false}
                onChange={props.onChange}
                disabled={!props.editable}
                style={{ padding: 0 }}
            />
        </Box>
    );
});

CheckboxFieldTable.propTypes = {
    value: PropTypes.bool,
    name: PropTypes.string,
    editable: PropTypes.bool,
    onChange: PropTypes.func,
};

CheckboxFieldTable.defaultProps = {
    editable: true,
    onChange: () => {},
};

export default CheckboxFieldTable;
